import { PaymentType } from '../models/PaymentType.enum';

const LIST_PAYMENTS_TYPE = [
  { value: PaymentType.CREDIT_CARD, name: 'Credit Card' },
  { value: PaymentType.ACH, name: 'ACH payment' },
  { value: PaymentType.INVOICE_PAYMENT, name: 'Account Payment Method' },
  { value: PaymentType.ALTERNATIVE_PAYMENT, name: 'Other Payment Method' },
  { value: PaymentType.E_WALLET_PAYMENT, name: 'eWallet Payment' },
  { value: 'all', name: 'All Payments Method' }
];

const OTHER_PAYMENTS_TYPE = [
  {
    name: "Cargo Sprint",
    value: "Cargo Sprint"
  },
  {
    name: "Pay Cargo",
    value: "Pay Cargo"
  },
  {
    name: "Cheque",
    value: "Cheque"
  },
  {
    name: "Cash",
    value: "Cash"
  }
];

const LIST_PAYMENTS_REPORT_TYPE = [
  { value: PaymentType.CREDIT_CARD, name: 'Trypod - Credit Card' },
  { value: PaymentType.ACH, name: 'Trypod - ACH payment' },
  { value: PaymentType.CREDIT_ACCOUNT, name: 'Trypod - Credit Account' },
  { value: PaymentType.CARGO_SPRINT, name: 'Cargo Sprint' },
  { value: PaymentType.PAY_CARGO, name: 'Pay Cargo' },
  { value: PaymentType.CASH, name: 'Cash' },
  { value: PaymentType.CHEQUE, name: 'Cheque' },
  { value: PaymentType.NOT_PAID, name: 'Not Paid' }
];

export {
  LIST_PAYMENTS_TYPE,
  LIST_PAYMENTS_REPORT_TYPE,
  OTHER_PAYMENTS_TYPE
};